import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useStatus } from './useStatus';
import { useColor } from './useColor';
import { useConfigContext } from '../config';
;
var typeDefs = {
  type: ['bar', 'circle'],
  percent: [Number, String],
  size: ['default', 'small', 'mini'],
  showOuterText: Boolean,
  showInnerText: Boolean,
  status: ['active', 'success', 'error', 'normal', 'warning'],
  strokeWidth: Number,
  color: [String, Array, Function]
};
var defaults = function defaults() {
  return {
    type: 'bar',
    percent: 0,
    size: 'default',
    showOuterText: true,
    status: 'active',
    strokeWidth: 6
  };
};
export var Progress = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Progress, _Component);
  function Progress() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.status = useStatus();
    _this.color = useColor();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Progress.prototype;
  _proto.init = function init() {
    var _this2 = this;
    this.on('$receive:percent', function (percent) {
      _this2.set('percent', fixPercent(percent));
    });
  };
  return Progress;
}(Component);
Progress.template = template;
Progress.typeDefs = typeDefs;
Progress.defaults = defaults;
function fixPercent(percent) {
  var _percent = Number(percent);
  if (_percent > 100) _percent = 100;
  if (_percent < 0) _percent = 0;
  return _percent;
}